<template>
  <div class="common-panel-container">
    <div class="title" v-if="ifShowTitle">
      <span class="text">
        <template v-if="title">{{title}}</template>
        <slot name="title" v-else></slot>
      </span>
      <span v-if="ifShowMore" class="ops" slot="extra">
        <a v-if="moreTarget === '_blank'" :href="moreLink" target="_blank">更多></a>
        <a v-else href="javascript:;" @click="moreLinkHandler">更多></a>
      </span>
      <span class='ops' v-if="needExtra">
        <slot name='extra'></slot>
      </span>
      <span class="aside" v-if="needAside">
        <slot name="aside"></slot>
      </span>
    </div>
    <div class="content" :style="{'padding-top': isShowPaddingTop ? paddingTopVal : '0px', 'padding-bottom': paddingBottomVal ? paddingBottomVal : '20px'}">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: "common-panel",
    props: {
      paddingTopVal: {
        type: String,
        default:'20px'
      },
      title: {
        type: String
      },
      // 更多跳转urk
      moreLink: {
        type: String
      },
      // 更多跳转target
      moreTarget: {
        type: String,
        default: '_self'
      },
      // 是否展示标题
      ifShowTitle: {
        type: Boolean,
        default: true
      },
      // 是否展示更多
      ifShowMore: {
        type: Boolean,
        default: false
      },
      needExtra: {
        type: Boolean,
        default: false
      },
      needAside: {
        type: Boolean,
        default: false
      },
      isShowPaddingTop : {
        type: Boolean,
        default: true
      },
      paddingBottomVal: {
        type: String,
        default: '20px'
      }
    },
    data() {
      return {}
    },
    methods: {
      moreLinkHandler () {
        this.$emit('moreLink')
      }
    },
  }
</script>

<style lang="scss" scoped>
.common-panel-container {
  background-color: #FFFFFF;
  > .title {
    padding: 0 20px;
    height: 50px;
    color: #333333;
    border-bottom: 1px solid $grey-f6;
    display: flex;
    align-items: center;
    .text {
      // width: 150px;
      font-size: 14px;
      font-weight: 600;
      color: #333333;
      display: inline-block;
      display: flex;
      align-items: center;
      &::before {
        content: '';
        display: inline-block;
        width: 3px;
        height: 12px;
        background: $text-blue;
        margin-right: 8px;
      }
    }
    /* 更多 */
    .ops {
      font-size: 13px;
      color: #666666;
      letter-spacing: 0;
      flex: 1;
      text-align: right;
      font-family: MicrosoftYaHei;
      a {
        line-height: 22px;
        color: #1C7AE5;
        text-decoration: none;
      }
    }
    /*其他附加信息*/
    .aside {
      font-size: 13px;
      line-height: 22px;
    }
  }
  > .content {
    padding: 0px 20px 20px 20px;
  }
}
</style>
